var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6356 21.3498C44.6021 21.3498 45.3856 22.1333 45.3856 23.0998V44.0998C45.3856 45.0663 44.6021 45.8498 43.6356 45.8498H22.6356C21.6691 45.8498 20.8856 45.0663 20.8856 44.0998C20.8856 43.1333 21.6691 42.3498 22.6356 42.3498H41.8856V23.0998C41.8856 22.1333 42.6691 21.3498 43.6356 21.3498Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6996 13.1639C13.383 12.4805 14.491 12.4805 15.1744 13.1639L44.8729 42.8624C45.5563 43.5458 45.5563 44.6538 44.8729 45.3372C44.1895 46.0207 43.0814 46.0207 42.398 45.3372L12.6996 15.6388C12.0162 14.9554 12.0162 13.8473 12.6996 13.1639Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDown);
export default __webpack_public_path__ + "static/media/arrow-right-down.a54c9500.svg";
export { ForwardRef as ReactComponent };